import React, { useContext } from 'react';
import AppLink from '../links/AppLink';
import clsx from 'clsx';
import styles from './SubNav.module.less';
import RequestContext from '../../services/RequestContext';
import { Dicon } from 'edcom-ui';
import Hamburger from './Hamburger';
import Dropdown from './Dropdown';
import PropTypes from 'prop-types';
import style from './SubNav.module.less';

export default function SubNav({ open = false, onClick, page }) {
  const subNavClasses = clsx(style.subNavMore, open && 'open');
  const { query } = useContext(RequestContext);
  let tsNow = Date.now();
  let seasonalLink =
    (tsNow > Math.round(new Date('2020/08/09 00:00:00').getTime()) &&
      tsNow < Math.round(new Date('2020/10/05 00:00:00').getTime())) ||
    query['seasonal-menu'];
  return (
    <nav className={style.subNav}>
      <div className={style.container}>
        <div className={subNavClasses}>
          <Hamburger onClick={onClick} desktopOnly={true} />
          <Dropdown open={open} page={page} />
          <div className={style.subNavLinks}>
            <ul>
              <li>
                <AppLink data-cid="11.2143" href="/worksheets/">
                  Worksheets
                </AppLink>
              </li>
              <li>
                <AppLink data-cid="11.2143" href="/games/">
                  Games
                </AppLink>
              </li>
              <li>
                <AppLink data-cid="11.2143" href="/lesson-plans/">
                  Lesson plans
                </AppLink>
              </li>
              <li>
                <AppLink data-cid="11.2143" href="/activities/">
                  Activities
                </AppLink>
              </li>
              <li>
                <AppLink data-cid="11.2143" href="/workbooks/">
                  Workbooks
                </AppLink>
              </li>
              <li>
                <AppLink data-cid="11.2143" href="/exercises/">
                  Exercises
                </AppLink>
              </li>
              <li>
                <AppLink data-cid="11.2143" href="/songs/">
                  Songs
                </AppLink>
              </li>
              <li>
                <AppLink data-cid="11.2143" href="/stories/">
                  Stories
                </AppLink>
              </li>
              {seasonalLink && (
                <li className={clsx(styles.mobileOnly, styles.summer)}>
                  <AppLink href="/back-to-school/" className={styles.text}>
                    <Dicon name="back-to-school" theme="red" />
                    Back to School
                  </AppLink>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
}

SubNav.propTypes = {
  open: PropTypes.bool,
  onClick: PropTypes.func,
  page: PropTypes.string,
};
